import React from "react";


export const Tab = props => <div className="steps">
  {props.tabs.map(tab => {
    if (props.open) return (<a
      className={`step ${props.actualState.state.step === tab.step ? "active" : ""}`}
      onClick={
        tab.setState
          ? () => props.actualState.setState(tab.setState)
          : () => null
      }
    >
      <span className="step-no"></span>
      <span className="step-desc">{tab.label}</span>
    </a>
    )
    else return (<a
      className={`step ${props.actualState.state.step > tab.step
        ? "completed"
        : props.actualState.state.step === tab.step
          ? "active"
          : ""
        }`}
      onClick={
        tab.setState && props.actualState.state.step > tab.step || props.open
          ? () => props.actualState.setState(tab.setState)
          : () => null
      }
    >
      <span className="step-no"></span>
      <span className="step-desc">{tab.label}</span>
    </a>)
  })}
</div>
